import { Grid, Card, CardContent } from '@material-ui/core';
import React, { Component, Fragment } from 'react';
import Loading from '../Loading'
import KPICard from './genericKPICard'
import BarChart from './meetingUsageChart';
//import teamFilterAPI from '../../flowtrace-api/dataAPI/teamFilters';
import meetingAPI from '../../flowtrace-api/meetingAPI';
import extensionAPI from '../../flowtrace-api/extensionAPI';


class FlowtraceMeetingOnlyUsageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, usage: { members:0, active:0, plugin:0 } };
  }


  async loadStatistics() {
    const usage = { members:0, active:0, plugin:0 };

    const [overview, meetingStats, extensionUsage] = await Promise.all([
      meetingAPI.overview(this.props.queryFilters, this.props.flowtraceUser),
      meetingAPI.distribution(this.props.queryFilters, this.props.flowtraceUser),
      extensionAPI.usage(this.props.queryFilters, this.props.flowtraceUser)
    ]);

    if(overview && overview.members && overview.members.length > 0) {
      usage.members = overview.members.length;
    }

    if(meetingStats && meetingStats.peopleMeetingTime) {
      meetingStats.peopleMeetingTime.forEach((pmt) => { usage.active += pmt.count; });
    }
    
    if(extensionUsage && extensionUsage.source) {
      extensionUsage.source.forEach((source) => { usage.plugin += source.users; });
    }
    

    this.setState({ loading: false, usage });
    return;
  }

  async componentDidMount() {
    this.loadStatistics();
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => { return; };
  }

  render() {
    if (this.state.loading)
      return (
        <Grid item xs={12} md={6} xl={4}>
          <Fragment >
            <Card>
              <CardContent >
                <div className="p-3 mt-3 font-weight-bold font-size-xl text-uppercase" >Team and Usage</div>
                <Loading minimize="true" />
              </CardContent>
            </Card>
          </Fragment>
        </Grid>
      );


    const leftHandColumn = [];
    const rightHandColumn = [];

    if (this.state.usage && (this.state.usage.members || this.state.usage.active || this.state.usage.plugin)) {
      const series = {
          name: 'All users',
          data: [{
            x:"",
            y: this.state.usage.members,
            goals: [
              {
                name: 'Active',
                value: this.state.usage.active,
                strokeHeight: 5,
                strokeColor: '#775DD0',
              },
            ],
        }]};
      const peopleMetadata = {
        title: "Users and meetings",
        series: [series],
      };
      leftHandColumn.push(<BarChart key="people_kpi" chartdata={peopleMetadata} />);
    }

    // Total users
    // Active/reported usage users (?)
    // Organized meetings
    // Attended meetings
    // Outlook / Chrome calendar plugin users
    // if (this.props.teamworkScore && this.props.teamworkScore.latestMovingAverage)
    //   rightHandColumn.push(<KPICard key="teamworkScore" KPI="team_teamwork" benchmark={this.props.benchmark} value={this.props.teamworkScore.latestMovingAverage} compareValue={this.props.teamworkScore.average} />);
    // if (this.props.teamCompositionScore && this.props.teamCompositionScore.latestMovingAverage)
    rightHandColumn.push(<KPICard key="pluginUsage" KPI="plugin_usage" value={this.state.usage.plugin} />);

    if (leftHandColumn.length === 0 && rightHandColumn.length === 0)
      return null; // Return nothing if there is no productivity data available



    return (
      <Grid item xs={12} md={6} xl={4}>
        <Fragment>
          <Card className="card-box mb-4">
            <CardContent className="p-0">
                <Grid container spacing={0}>
                  <Grid item xs={12} sm={6}>
                    <div className="pl-3 mt-3 font-weight-bold font-size-xl text-uppercase" >Flowtrace Usage</div>
                    {leftHandColumn}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {rightHandColumn}
                  </Grid>
                </Grid>
            </CardContent>
          </Card>
        </Fragment>
      </Grid>
    ); // end of return
  } // end of render()
} // end of class

export default FlowtraceMeetingOnlyUsageComponent;
